export namespace AlarmManagementModel {
  export enum AlarmStatus {
    CANCELED = 0,
    ACTIVE = 1,
  }

  export interface AlarmData {
    id: string;
    orgId: string;
    locationId: string;
    status: AlarmStatus;
    dispatchTime: string;
    cancelTime?: string;
    cancelBy?: string;
  }

  export interface CreateAlarm {
    locationId: string;
    uniformId?: string;
  }

  export interface CancelAlarm {
    alarmId: string;
    cancelBy: string;
  }

  export interface AlarmFilter {
    status?: AlarmStatus;
    locationId?: string;
    fromDate?: string;
    toDate?: string;
  }

  export interface AlarmCheckResponse {
    hasActiveAlarm: boolean;
    activeAlarm?: AlarmData;
  }
}
